export default __webpack_public_path__ + "static/media/OTT.6e947343.svg";